import React, { Component, useState } from "react";
import { Alert, UncontrolledTooltip } from "reactstrap";
import { MdErrorOutline } from "react-icons/md";
import { RelevantIcon, unsetAllPopovers, handleFilter, getBusinessControls, toTitleCase, getCookie, getDisplayedTabUID, getMissingFields, closeSidebar } from "../oro-module/commonFunctions";
import moment from "moment";
import { handleSearch, handleConfirmSubmit, handlePageChange } from "../oro-module/ajaxdata";
import { createComponent } from "../FormArea/FormContent";
import requiredFields from "../oro-module/requiredFields";

const styles = {
  requiredFields: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid gold",
    textAlign: "left"
  },
  formErrors: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid gold",
    textAlign: "left",
    maxWidth: 500
  }
};


const LoadingSpinner = () => {
  return (
    <div className={`page-specific-icons `} style={{ width: 80, textAlign: "center" }} >
      <span className="action-button-spinner"> <img height="25" width="25" src="/images/gif/spinner-min.gif" />
      </span>
    </div>
  )
}

const cleanupFieldNames = (fields) => {

  return fields.map(f => {
    if (f.indexOf('[') != -1) {
      console.log({ f })
      let f1 = f.split(']');
      let f2 = f1[f1.length - 2].split('[')
      return f2[f2.length - 1];
    } else if (f.indexOf('.') != -1) {
      let f1 = f.split('.');
      return f1[f1.length - 1];
    }
    else if (f.indexOf('-') != -1) {
      let f1 = f.split('-');
      return f1[f1.length - 1];
    }
    else {
      return f;
    }
  })
}

const PageSpecificOptions = ({ current }) => {




  // const [confirmState, setConfirmState] = useState(false);
  const [btntext, setbtntext] = useState(false);
  const [fromDB, setFromDB] = useState(false);


  let { identi, val3, val4 } = current.props.parentProps.parentState;





  let buttonStyles = {
    'finalsubmit': 'FINAL SUBMIT',
    'sendtotehsildar': 'APPROVE'
  }



  let confirmMessages = {
    irreversible: "Acknowledgement of FINAL SUBMISSION: I hereby confirm that the audit has been completed and the findings of the same shall not be altered.\n  मैं एतद्द्वारा पुष्टि करता हूं कि ऑडिट पूरा हो गया है और उसके निष्कर्षों में कोई बदलाव नहीं किया जाएगा।",
    irreversiblereport: "Acknowledgement of FINAL SUBMISSION: I hereby confirm that the reporting has been completed and the findings of the same shall not be altered.\n  मैं एतद्द्वारा पुष्टि करता हूं कि reporting पूरा हो गया है और उसके निष्कर्षों में कोई बदलाव नहीं किया जाएगा।",
    marathimsg: "Acknowledgement of FINAL SUBMISSION: मी याद्वारे पुष्टी करतो की फाइल तपासली गेली आहे आणि त्यामधील बँकेतल्या  खात्यांशी जुळलेली खाती पुढील प्रक्रियेसाठी पाठवायची आहेत.",
  }




  let confirmButtonClass = 'confirm';
  let confirmButtonText = "CONFIRM";

  if (btntext && buttonStyles[btntext]) {
    confirmButtonText = buttonStyles[btntext];
    confirmButtonClass = "darkgreen-confirm";
  }

  let {
    currentPage,
    formElements,
    LocalVars,
    businessControlOpen,
    pageData,
    isSearching,
    isSubmitting,
    showButtons,
    wizard,
    grid,
    theme,
    openControls
  } = current.props.parentState;

  let { form, filter, filteraction, formActions, submitLogic, insertButton, moreOptions } = formElements[currentPage] ? formElements[currentPage] : [];
  let { ShowHistory, fullscreenreport, confirmState } = LocalVars;

  const setConfirmState = (act) => {
    LocalVars['confirmState'] = act;
    current.props.liftGlobalState({ name: 'LocalVars' }, LocalVars);
  }

  const finalSubmit = () => {
    let { pageData } = current.props.parentState;

    let missing = getMissingFields({ pageData });

    let otherPageData = { submit_type: "submit" };
    // if key from required fields has no value in pageData, then push to missing.


    // console.log({ missing, submitLogic, pageData });

    if (missing.length == 0) {
      if (submitLogic && submitLogic.doubleConfirm && (((pageData.unique_id && submitLogic.onlyOnUpdate) || (!pageData.unique_id && !submitLogic.onlyOnUpdate)) || pageData.acknowledge)) {
        let defaultMsg = "\nPlease type\nconfirm\nin the box below to confirm this action.";
        let msg = confirmMessages[submitLogic.doubleConfirm] ? confirmMessages[submitLogic.doubleConfirm] + defaultMsg : "Please type\nconfirm\nin the box below to confirm this action."
        let feedback = prompt(msg);
        if (feedback == 'confirm') {
          current.props.liftState({ name: 'acknowledge' }, true);
          current.props.liftState({ name: 'acknowledged_on' }, new Date());
          setConfirmState(false);
          handleConfirmSubmit({ current, otherPageData, act: confirmState });
        } else {
          alert("Invalid Input.")
        }
      } else {
        setConfirmState(false);
        handleConfirmSubmit({ current, otherPageData, act: confirmState });
      }
    } else if (submitLogic && submitLogic.allowPartialSubmit) {
      setConfirmState(false);
      handleConfirmSubmit({ current, otherPageData, act: confirmState });
    } else if (!submitLogic || !submitLogic.allowPartialSubmit) {
      alert("Mandatory fields missing.\n" + cleanupFieldNames(missing).map((m, idx) => (idx + 1) + '. ' + toTitleCase(m.replace(/_/g, ' '))).join("\n"));
    }
  }

  const checkRequiredAndSetConfirm = (act) => {
    // make silhouette on the the entire form so that the user doesnt make any changes till clicking cancel.


    if (act == 'update' || act == 'create' || act == 'accept') {
      // Check if all the fields in requiredFields have been filled. If not, check whether allowPartialSubmit is true for the page.
      // if key from required fields has no value in pageData, then push to missing.
      let { pageData } = current.props.parentState;
      let missing = getMissingFields({ pageData });
      console.log({ missing, submitLogic, pageData, act });

      // if unique_id has new_ && act==update then act=create.

      if (missing.length == 0) {
        if (submitLogic && submitLogic.submitText && (((!pageData.acknowledge && pageData.unique_id && submitLogic.onlyOnUpdate) || (!pageData.acknowledge && !pageData.unique_id && !submitLogic.onlyOnUpdate)) || pageData.acknowledge)) {
          console.log({ missing, submitLogic, pageData });

          setConfirmState(act);
          setbtntext(submitLogic.submitText);
        } else {
          setbtntext(false);
          setConfirmState(act);
        }
      } else if (submitLogic && submitLogic.allowPartialSubmit) {
        setConfirmState(act);
      } else if (!submitLogic || !submitLogic.allowPartialSubmit) {
        alert("Mandatory fields missing.\n" + cleanupFieldNames(missing).map((m, idx) => (idx + 1) + '. ' + toTitleCase(m.replace(/_/g, ' '))).join("\n"));
      }
    } else {
      setConfirmState(act);
    }
  }


  let allc = getBusinessControls(filter, pageData);

  const handleActiveControl = (id) => {
    unsetAllPopovers();
    current.props.liftGlobalState({ name: "businessControlOpen" }, id);

    // if (businessControlOpen == id) {
    //   current.props.liftGlobalState({ name: "businessControlOpen" }, false);
    //   // document.getElementById("business-controls").style.visibility = "hidden";
    // } else {
    //   current.props.liftGlobalState({ name: "businessControlOpen" }, id);
    //   // document.getElementById("business-controls").style.visibility = "visible";
    // }
  }


  const createDates = ({ start, freq, steps }) => {
    let alldates = [];
    for (var i = 0; i < freq; i++) {
      let prev = moment(start).subtract(i, 'day').toISOString();
      alldates.push(prev);
    }
    return alldates;
  }

  function swait(ms) {
    var start = Date.now(),
      now = start;
    while (now - start < ms) {
      now = Date.now();
    }
  }

  const handleSearchButtonClicked = async ({ current, pageData }) => {
    setFromDB(false);
    // Check whether iterative is on.
    let { isIterative, as_on_date, isBulk } = pageData;
    if (isIterative) {
      const multiDownload = async (current, alldates, i) => {
        if (i < alldates.length) {
          let dat = alldates[i];
          current.props.liftState({ name: "as_on_date" }, dat);
          await handleSearch({ current, pageData });
          let textbtn = document.getElementById('text-download-button-full');
          if (textbtn) {
            current.props.liftGlobalState({ name: "textPageSize" }, "Recon");
            textbtn.click();
          }
          let notifications = { value: `Completed ${i + 1}/${totalreps}`, alertType: "status" };
          current.props.liftGlobalState({ name: "notifications" }, notifications);
          i += 1;
          console.log("DOWNLOADED");
          setTimeout(() => multiDownload(current, alldates, i), 100);
        }
      }

      // create a list of dates.
      let { iterIterations, iterationSchedule } = pageData;
      let alldates = createDates({ start: as_on_date, freq: iterIterations, steps: iterationSchedule });
      let totalreps = alldates.length;
      // for (var i = 0; i < alldates.length; i++) {
      multiDownload(current, alldates, 0);
      // }
    }
    else if (isBulk) {
      // get the reports list from bulk footers control.
      // Go to those reports. Download text (with name), csv, pdf etc.
      let reports = ["rprbi1", "rprbi3", "rprbi5", "rprbi9", "rprbi13", "rprbi14", "rprbi15", "rprbi19", "rprbi20", "rprbi21", "rprbi23", "rprbi28", "rprbi29", "rprbi30", "rprbi32", "rprbi33"];//"rprbi2", "rprbi26",  "rprbi10",
      let totalreps = reports.length;

      let extentions = ["xlsx"]; //,"csv", "txt"
      const BulkDownload = async (current, reports, i) => {
        if (i < reports.length) {
          let r = reports[i];
          handlePageChange({ item: { fastpath: r, label: r }, current });
          await handleSearch({ current, pageData });
          if (extentions.indexOf('csv') != -1) {
            let csvbtn = document.getElementById('csv-download-button-full');
            if (csvbtn) {
              csvbtn.click();
            }
          }
          if (extentions.indexOf('xlsx') != -1) {
            let csvbtn = document.getElementById('xlsx-download-button');
            if (csvbtn) {
              csvbtn.click();
            }
          }

          if (extentions.indexOf('txt') != -1) {
            let textbtn = document.getElementById('text-download-button-full');
            if (textbtn) {
              current.props.liftGlobalState({ name: "textPageSize" }, "LBS");
              textbtn.click();
            }
          }

          let notifications = { value: `Completed ${i + 1}/${totalreps}`, alertType: "status" };
          current.props.liftGlobalState({ name: "notifications" }, notifications);
          i += 1;
          console.log("DOWNLOADED");
          setTimeout(() => BulkDownload(current, reports, i), 100);
        }
      }
      BulkDownload(current, reports, 0);


    }
    else {
      handleSearch({ current, pageData });
      if ((!form || form.length == 0) && fullscreenreport) {
        current.props.liftGlobalState({ name: "full_report" }, true);
      }
    }
  }

  const handleGetFromDBClick = (e) => {
    setFromDB(!fromDB);
  }


  let icons = [
    { id: "basic", icon: 'settings-color', style: { fontSize: 20, color: "#505050" }, tab: "business", tip: "Basic" },
    { id: "advance", icon: 'star', style: { fontSize: 20, color: "#505050" }, tab: "business", tip: "Advance" },
  ];

  let moreicons = [
    { id: "more", icon: 'star', style: { fontSize: 20, color: "#505050" }, tab: "business", tip: "Advance" }
  ];

  let ActionButton = () => {
    let ab = "accept,revert";
    return (
      <span>

        {!pageData.can_auth &&
          <span onClick={() => checkRequiredAndSetConfirm('update')} className={`page-specific-icons `} style={{}} >
            <span className="action-button static" id="action-button-search"><RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="save" /> UPDATE
              {/* 
              {(pageData.unique_id && submitLogic && submitLogic.onlyOnUpdate && submitLogic.labels && submitLogic.labels.save && submitLogic.labels.save)}

              {(!pageData.unique_id && <span>SAVE</span>)} */}

            </span>
          </span>
        }


        {pageData.can_auth && ab.split(",").map((btn, idx) => {
          btn = btn.trim();
          return (
            <span key={idx} onClick={() => checkRequiredAndSetConfirm(btn)} className={`page-specific-icons `} style={{}} >
              <span className={`action-button ${btn}`} id="action-button-search"><RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon={btn} /> {btn}
              </span>
            </span>
          )
        })
        }
      </span>
    )
  };

  let deletelabel = "Delete";
  if (formActions && formActions.delete) {
    if (formActions.delete.label) { deletelabel = formActions.delete.label; }
  }

  let showSearchButton = false;
  let showLoading = false;
  let showconfirmbuttons = false;
  if (openControls && openControls.length > 0 && !isSearching) { showSearchButton = true; }
  if ((openControls && openControls.length > 0 && isSearching) ||
    ((!openControls || openControls.length == 0) && ShowHistory && isSearching && showButtons.search)
  ) { showLoading = true; }

  if (
    ((!openControls || openControls.length == 0) && !isSubmitting && !ShowHistory && confirmState && pageData.unique_id && formActions.edit && formActions.edit.allow) ||
    ((!openControls || openControls.length == 0) && !isSubmitting && !ShowHistory && showButtons.submit && confirmState)
  ) {
    showconfirmbuttons = true;
  }



  return (
    <div className="row"
      style={{ float: "right" }}
    >
      {fromDB &&
        <div className="oro-tooltip row" style={{ top: 105, width: 200 }}>
          {createComponent({ allc: allc['action'], selectedFormTab: "", wizard, grid, current, theme, showtag: true })
          }
        </div>
      }

      <div className="col-sm-12" >
        {(form || filter) &&
          <span>

            {openControls && openControls.length > 0 && !isSearching &&
              <div className={`action-button-container`} >
                <div style={{ float: 'left' }} onClick={() => handleSearchButtonClicked({ current, pageData })} className={`action-button static ${filteraction ? 'hasappend' : ''}`} id="action-button-search">
                  <RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="search" /> {form && form.length > 0 ? 'Search' : 'GO'}
                </div>
              </div>
            }


            {showLoading && <LoadingSpinner />}

            {(!openControls || openControls.length == 0) && ShowHistory && !isSearching && showButtons.search && !businessControlOpen &&
              <div className={`action-button-container`} >
                <div style={{ float: 'left' }} onClick={() => handleSearchButtonClicked({ current, pageData })} className={`action-button static ${filteraction ? 'hasappend' : ''}`} id="action-button-search">
                  <RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="search" /> {form && form.length > 0 ? 'Search' : 'GO'}
                </div>
                {filteraction &&
                  <div style={{ float: 'left' }} onClick={(e) => handleGetFromDBClick(e)} className="action-button-append">
                    <RelevantIcon icon="down-carat" style={{ fontSize: 20 }} />
                  </div>
                }
              </div>
            }

            {(!openControls || openControls.length == 0) && ShowHistory && !isSearching && showButtons.search && !businessControlOpen && insertButton &&
              <div className={`action-button-container`} >
                <div style={{ float: 'left' }} onClick={() => { handleFilter({ current, act: 'hide' }); closeSidebar(current); }} className={`action-button accept ${filteraction ? 'hasappend' : ''}`} id="action-button-search">
                  {/* <RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="plus-color" />  */}
                  {insertButton.label}
                </div>
              </div>
            }


            {(!openControls || openControls.length == 0) && !isSubmitting && !ShowHistory && showButtons.submit && !confirmState && !pageData.unique_id &&
              <div onClick={() => checkRequiredAndSetConfirm('create')} className={`page-specific-icons `} style={{}} >
                <span className="action-button static" id="action-button-search"><RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="save" /> SAVE
                </span>
              </div>
            }

            {(!openControls || openControls.length == 0) && !isSubmitting && !ShowHistory && !confirmState && pageData.unique_id && formActions.edit && formActions.edit.allow &&
              <ActionButton />
            }

            {(!openControls || openControls.length == 0) && !isSubmitting && !ShowHistory && showButtons.submit && !confirmState && pageData.unique_id && formActions.delete && formActions.delete.allow &&
              <div onClick={() => checkRequiredAndSetConfirm('delete')} className={`page-specific-icons `} style={{}} >
                <span className="action-button danger" id="action-button-search"><RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="delete" /> {deletelabel}
                </span>
              </div>
            }


            {showconfirmbuttons &&
              <div className={`page-specific-icons `} style={{}} onClick={() => finalSubmit()} >
                <span className={`action-button ${confirmButtonClass}`} id="action-button-search"><RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="save" /> {confirmButtonText}
                </span>
              </div>
            }

            {showconfirmbuttons &&
              <div className={`page-specific-icons `} style={{}} onClick={() => checkRequiredAndSetConfirm(false)} >
                <span className="action-button cancel" id="action-button-search"><RelevantIcon style={{ fontSize: 20, marginBottom: -5 }} icon="cross" /> CANCEL
                </span>
              </div>
            }

            {(!openControls || openControls.length == 0) && isSubmitting && !ShowHistory &&
              <div className={`page-specific-icons `} style={{ width: 80, textAlign: "center" }} >
                <span className="action-button-spinner"> <img height="25" width="25" src="/images/gif/spinner-min.gif" />
                </span>
              </div>
            }

            {(!openControls || openControls.length == 0) && form && form.length != 0 && ShowHistory && moreOptions &&
              moreicons.map(({ icon, id, style = {}, tip = "", tab }, idx) => {
                let ttid = icon + tab;
                return (
                  <div key={idx} onClick={() => handleActiveControl(id)} className={`${businessControlOpen == id ? 'tab-selected' : ''} page-specific-icons `} id={ttid} >
                    <RelevantIcon icon={icon} style={{ ...style, float: "left" }} />
                    <span style={{ float: "left" }}>&nbsp; {tip}</span>
                  </div>
                )
              })
            }


            {(!openControls || openControls.length == 0) && (!form || form.length == 0) && moreOptions &&
              icons.map(({ icon, id, style = {}, tip = "", tab }, idx) => {
                let ttid = icon + tab;
                return (
                  <div key={idx} onClick={() => handleActiveControl(id)} className={`${businessControlOpen == id ? 'tab-selected' : ''} page-specific-icons `} id={ttid} >
                    <RelevantIcon icon={icon} style={{ ...style, float: "left" }} />
                    <span style={{ float: "left" }}>&nbsp; {tip}</span>
                  </div>
                )
              })
            }
          </span>
        }


      </div>




    </div>
  )
}


function makeErrorsList(errorMessages, res = [], modalname = "") {

  Object.keys(errorMessages).map((v, i) => {
    if (errorMessages[v]) {
      if (typeof errorMessages[v] == 'string') {
        res.push(<li key={i}><i>{varToLabel(errorMessages[v])}</i> {" in "} <b>{varToLabel(v)}</b> {modalname ? " At " + modalname : ""} </li>)
      } else if (typeof errorMessages[v] == 'object') {
        res.concat(makeErrorsList(errorMessages[v], res, modalname))
      }
    }
  }
  )
  return res;
}

function toCamelCase(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index == 0 ? word.toUpperCase() : word.toUpperCase();
  }).replace(/\s+/g, ' ');
}
function varToLabel(varname) {
  return toCamelCase(varname.replace(/_/g, " "));
}

class PageName extends Component {
  render() {

    let {
      currentPage,
      alerts,
      formElements,
      formProgress,
      errorMessages,
      openmodals,
      LocalVars,
      openControls
    } = this.props.parentState;

    let { identi, val3, val4 } = this.props.parentProps.parentState;
    // console.log({ identi, val3, val4 })

    // if (openControls.length > 0) { currentPage = openControls[openControls.length - 1]['fastpath']; }

    let pageLabel;
    pageLabel = formElements[currentPage] ? formElements[currentPage].pageLabel : '';
    // let {pageLabel}=formElements[currentPage]
    let { themecolor } = this.props.parentState;
    let { currentUser } = this.props.parentState;
    let displayErrors = 0;
    Object.keys(errorMessages).map((v, i) =>
      errorMessages[v] ? displayErrors += 1 : ""
    );
    let modalname = openmodals[openmodals.length - 1];
    let allFormErrors = makeErrorsList(errorMessages, [], modalname);

    return (
      <div className="row" style={{ height: 50 }}>

        <div className="col-sm-7 pagename-container">
          <div className={`${themecolor}-page-theme`}>
            <span style={{ fontSize: 24 }}>{pageLabel}</span>
            {/* <i style={{ color: "gray", fontSize: 14 }}>&nbsp; {currentPage.split('.')[0]}</i> */}

            {/* {formProgress.length > 0 &&
              <span>
                &nbsp;
                <MdErrorOutline
                  id="formProgress"
                  style={{
                    fontSize: "20px",
                    // border: "1px solid #ced4da",
                    // borderRadius: "0.25rem",
                    color: "#e7305b",
                    borderColor: "white",
                  }}
                // className="animated pulse infinite hand"
                />
                <UncontrolledTooltip style={styles.requiredFields} placement="bottom" target="formProgress">
                  <b>Required fields</b>
                  <ol>
                    {formProgress.map((v, i) =>
                      <li key={i}>{v.msg ? varToLabel(v.val) + " in " + v.msg : varToLabel(v.val)}</li>
                    )
                    }
                  </ol>
                </UncontrolledTooltip>
              </span>
            } */}
            {/* {LocalVars.showFilter && <span className="form-mode"> (Search Form)</span>}
            {!LocalVars.showFilter && <span className="form-mode green"> (Create Form)</span>} */}
          </div>
        </div>

        <div className="col-sm-5">
          <PageSpecificOptions
            current={this}
          />
        </div>



        {/* <div className="col-sm-6">
          {allFormErrors.length > 0 &&
            <Alert
              style={{
                marginBottom: "0px",
                padding: "0px 20px"
              }}
              color="warning"
            >

              {allFormErrors.length == 1 &&
                <span>
                  {allFormErrors[0]}
                </span>
              }

              {allFormErrors.length > 1 &&
                <span>
                  <span> Error Occured </span>
                  <MdErrorOutline
                    id="errorMessagesList"
                    style={{
                      fontSize: "20px",
                      color: "#e7305b",
                      borderColor: "white",
                    }}
                  />
                  <UncontrolledTooltip style={styles.formErrors} placement="bottom" target="errorMessagesList">
                    <b>Form Errors</b>
                    <ol>
                      {allFormErrors.map(v => v)}
                    </ol>
                  </UncontrolledTooltip>
                </span>
              }
            </Alert>
          }
        </div> */}
      </div>
    );
  }
}

export default PageName;

